<template>
	<v-card class="cardStyle mt-10">
		<v-col class="text-center" align-self="center">
			<template v-if="plan.best_deal">
				<div class="badge-overlay">
					<span class="top-right badge assistant">{{
						$t("pages.price.bestDeal")
					}}</span>
				</div>
			</template>
			<v-card class="innerCardStyle pt-10 bestseller" elevation="0">
				<v-card-subtitle
					class="assistant text-center innerCardTitle headline white--text mb-8"
				>
					{{ plan.title }}
				</v-card-subtitle>
				<v-card-text v-if="!isFree">
					<span class="display-2 pa-1 textColor">{{ plan.price }}</span>
					<span class="textColor">{{ $t("pages.price.nis") }}</span>
				</v-card-text>
				<v-card-text v-else>
					<span class="display-2 pa-1 textColor">חינם</span>
				</v-card-text>
				<v-card-text class="mb-4">
					<span class="textColor">
						{{ $t("pages.price.canMake") }} <br />
						<span v-if="isFree">
							נסו את ClapLab וצרו עד {{ additional.num_games }} משחקים בחינם
						</span>
						<span v-else>{{
							additional.num_games + " " + $t("pages.price.gamesPerYear")
						}}</span>
					</span>
				</v-card-text>
				<v-btn class="pa-5" id="yellowBtn" :href="link">{{
					$t("pages.price.buy")
				}}</v-btn>
			</v-card>
		</v-col>
	</v-card>
</template>

<script>
export default {
	name: "PlanCard",
	props: { plan: Object },
	computed: {
		isFree() {
			return +this.plan.price === 0;
		},
		link() {
			return this.isFree
				? `/payment/free/${this.plan.hash}`
				: `/payment/${this.plan.hash}`;
		},
		additional() {
			return JSON.parse(this.plan.additional || "{}");
		}
	}
};
</script>
